module.exports = __webpack_public_path__ + "static/media/2016_conf_Tools_for_Better_Products.48a8270f.png";